<div class="row mobile-button-and-count" *ngIf="isMobile">
  <div class="col-8">
    <a class="btn {{hasFiltersApplied ? 'btn-primary' : 'btn-outline-dark'}}" (click)="toggleSidebar(true)">
      <svg xmlns="http://www.w3.org/2000/svg" width="25px" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z" />
      </svg>
      {{mobileButtonText}}
      <svg xmlns="http://www.w3.org/2000/svg" width="18px" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg>
    </a>
  </div>
  <div class="col-4 bottomtext" *ngIf="itemCount && itemType">
    <span class="content text-align-right">{{itemCount}} {{itemType | translate}} </span></div>
</div>

<div class="sidebar-filters" [ngClass]="{'open' : sidebarOpen}" *ngIf="isMobile">
  <div class="card p-1" [ngClass]="{'show' : sidebarOpen}">
    <div class="row mobile-filter-reset">
      <div class="col-9" >
        <a class="text-primary font-small-2" (click)="onResetAllFilters()">{{"FLEXIBLE_FIXED_BENEFITS.RESET_FILTER" | translate}}</a>
      </div>
      <div class="col-3 text-align-right">
        <button id="filters-popup-close-button" (click)="toggleSidebar(false)">
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.4083 10.0915C11.6416 10.3248 11.6416 10.6748 11.4083 10.9082C11.2916 11.0248 11.175 11.0832 11 11.0832C10.825 11.0832 10.7083 11.0248 10.5916 10.9082L7.49996 7.8165L4.40829 10.9082C4.29163 11.0248 4.17496 11.0832 3.99996 11.0832C3.82496 11.0832 3.70829 11.0248 3.59163 10.9082C3.35829 10.6748 3.35829 10.3248 3.59163 10.0915L6.68329 6.99984L3.59163 3.90817C3.35829 3.67484 3.35829 3.32484 3.59163 3.0915C3.82496 2.85817 4.17496 2.85817 4.40829 3.0915L7.49996 6.18317L10.5916 3.0915C10.825 2.85817 11.175 2.85817 11.4083 3.0915C11.6416 3.32484 11.6416 3.67484 11.4083 3.90817L8.31663 6.99984L11.4083 10.0915Z" fill="black"/>
            <mask id="mask0_446_168" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="2" width="9" height="10">
              <path d="M11.4083 10.0915C11.6416 10.3248 11.6416 10.6748 11.4083 10.9082C11.2916 11.0248 11.175 11.0832 11 11.0832C10.825 11.0832 10.7083 11.0248 10.5916 10.9082L7.49996 7.8165L4.40829 10.9082C4.29163 11.0248 4.17496 11.0832 3.99996 11.0832C3.82496 11.0832 3.70829 11.0248 3.59163 10.9082C3.35829 10.6748 3.35829 10.3248 3.59163 10.0915L6.68329 6.99984L3.59163 3.90817C3.35829 3.67484 3.35829 3.32484 3.59163 3.0915C3.82496 2.85817 4.17496 2.85817 4.40829 3.0915L7.49996 6.18317L10.5916 3.0915C10.825 2.85817 11.175 2.85817 11.4083 3.0915C11.6416 3.32484 11.6416 3.67484 11.4083 3.90817L8.31663 6.99984L11.4083 10.0915Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_446_168)">
              <rect x="0.5" width="14" height="14" fill="#6E6B7B"/>
            </g>
          </svg>
        </button>
      </div>
    </div>
    <div class="mobile-filters" [perfectScrollbar]>
        <app-sidebar-cashback-shop-category-filter
        *ngIf="categories?.length"
        [categories]="categories"
        (changeFilters)="emitFilters($event)">
      </app-sidebar-cashback-shop-category-filter>
    </div>
    <div class="row mobile-filter-reset">
      <div class="col-6 text-align-right">
        <div class="d-flex btn btn-primary justify-content-center align-self-right" (click)="toggleSidebar(false); applyFiltersBtnClicked()">
          {{"BENEFITS_FILTER.ADD_FILTERS" | translate}}
        </div>
      </div>

    </div>
  </div>
</div>

<div class="sidebar-filters" *ngIf="!isMobile">

  <div class="reset-filters">
    <div class="filters-title">{{"FLEXIBLE_FIXED_BENEFITS.TITLE_FILTER" | translate}}</div>
    <div class="filters-button" (click)="onResetAllFilters()">
      {{"FLEXIBLE_FIXED_BENEFITS.RESET_FILTER" | translate}}
    </div>
  </div>

  <span [ngbTooltip]="!applyFiltersBtnEnabled ? ('BENEFITS_FILTER.DISABLED_TOOLTIP' | translate) : null"
        container="body">
    <div class="d-flex justify-content-center mb-2">
      <button class="btn btn-primary btn-block" [disabled]="!applyFiltersBtnEnabled" (click)="applyFiltersBtnClicked()">
        {{"BENEFITS_FILTER.ADD_FILTERS" | translate}}
      </button>
    </div>
  </span>

  <div class="card p-1">
    <app-sidebar-cashback-shop-category-filter
    *ngIf="categories?.length"
    [categories]="categories"
    (changeFilters)="emitFilters($event)">
  </app-sidebar-cashback-shop-category-filter>
  </div>
</div>
